import { formatDate } from './dateUtils';

export type StatementTemplateValues = Record<string, string>;

/** Replaces statement merge fields while leaving unknown fields visible for correction. */
export const renderStatementTemplate = (template: string | null | undefined, values: StatementTemplateValues) =>
  (template || '').replace(/{{\s*([a-z_]+)\s*}}/gi, (field, key) => values[key.toLowerCase()] ?? field);

export const formatStatementCurrency = (amount: number | null | undefined) => {
  const value = Number(amount || 0);
  const sign = value < 0 ? '-' : '';
  return `${sign}R ${Math.abs(value).toFixed(2)}`;
};

export const buildStatementTemplateValues = (data: any): StatementTemplateValues => {
  const owner = data.account?.owners?.[0];
  return {
    owner_name: owner?.full_name || 'Owner',
    owner_email: owner?.email || '',
    account_number: data.account?.account_number || '',
    unit_number: data.account?.flat?.flat_number || '',
    property_address: data.account?.flat?.physical_address || '',
    body_corporate_name: data.bodyCorporate?.name || 'Body Corporate',
    statement_date: formatDate(data.generatedDate),
    period_from: formatDate(data.periodFrom),
    period_to: formatDate(data.periodTo),
    due_date: formatDate(data.dueDate || data.periodTo),
    amount_due: formatStatementCurrency(data.summary?.amount_due),
    payment_reference: data.account?.account_number || '',
  };
};

export const statementMergeFieldHelp = '{{owner_name}}, {{account_number}}, {{unit_number}}, {{property_address}}, {{body_corporate_name}}, {{statement_date}}, {{period_from}}, {{period_to}}, {{due_date}}, {{amount_due}}, {{payment_reference}}';
